import { GQLPlatformMerchantOrder } from '@jewelutions/core-crm-server-api-client-domain';
import { GQLEngravingHelper } from './GQLEngravingHelper';

export class GQLPlatformMerchantOrderHelper {
  static getOrderAssets(
    order: GQLPlatformMerchantOrder
  ): { pieceIds: string[]; accessoryIds: string[]; fontIds: string[]; symbolIds: string[] } {
    const resultPieceIds: string[] = [];
    const resultAccessoryIds: string[] = [];
    const resultFontIds: string[] = [];
    const resultSymbolIds: string[] = [];

    order.items.forEach(item => {
      if (item.pieceOrderItem) {
        resultPieceIds.push(item.pieceOrderItem.pieceReference.pieceId);
        const { fontIds, symbolIds } = GQLEngravingHelper.getEngravingAssets(
          item.pieceOrderItem!.engravings!
        );
        resultFontIds.push(...fontIds);
        resultSymbolIds.push(...symbolIds);
      }
      if (item.accessoryOrderItem) {
        resultAccessoryIds.push(item.accessoryOrderItem.accessoryReference.accessoryId);
      }
    });

    return {
      pieceIds: resultPieceIds,
      accessoryIds: resultAccessoryIds,
      fontIds: resultFontIds,
      symbolIds: resultSymbolIds
    };
  }
}
